module.exports = __webpack_public_path__ + "img/title7.6d53182e.png";